import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import usersHeaders from "@/pages/Maintenance/Users/usersHeaders";

export default {
	state: {
		usersItem: null,
		usersList: null,
		usersFilters: null,
		usersTotals: null,
		usersLimit: null,
		usersOrder: null,
		usersSort: null,
		usersTotal: null,
	},
	mutations: {
		updateUsersList(state, { row, limit, order, sort, total }) {
			state.usersList = row;
			state.usersLimit = limit;
			state.usersOrder = order;
			state.usersSort = sort;
			state.usersTotal = total;
			state.usersTotals = { id: total };
		},
		updateUsersFilters(state, { filter }) {
			state.usersFilters = filter;
		},
		getDriverDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDriverDeleteFiles', { id, isDelete });
		},
		updateUsersItem(state, payload) {
			state.usersItem = payload;
		}
	},
	actions: {
		async getUsers({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/users/list', filters);

				if (data && !data.status) {
					commit('updateUsersList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.USERS, defaultHeader: usersHeaders });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getUsersFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/users/filters', values);
				if (data) commit('updateUsersFilters', data);
			} catch (e) {
				console.error(e);
			}
		},
		async onUsersSave({ dispatch }, { id, ...values }) {
			dispatch("actionPreloader", true);
			await dispatch('onContractDelete');
			const url = id ? `/users/${ id }` : '/users';
			const requestKey = id ? 'put' : 'post';
			try {
				const { data } = await httpClient[requestKey](url, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async onUsersRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/users/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getUsersItem({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			const requestUrl = id ? `/users/${ id }/edit` : "/users/create";
			try {
				const { data } = await httpClient.get(requestUrl);

				if (data && !data.status) {
					commit("updateUsersItem", data);
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getCompanyUsers({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/users/create/?customer_id=${ id }`);

				if (data && !data.status) {
					commit("updateUsersItem", data);
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		}
	},
	getters: {
		usersItem: (s) => s.usersItem,
		usersList: (s) => s.usersList,
		usersFilters: (s) => s.usersFilters,
		usersTotals: (s) => s.usersTotals,
		usersLimit: (s) => s.usersLimit,
		usersOrder: (s) => s.usersOrder,
		usersSort: (s) => s.usersSort,
		usersTotal: (s) => s.usersTotal,
	}
};
